module.exports = __webpack_public_path__ + "static/media/speaker_IBM_ArunVishwanath.db030124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_IBM_ArunVishwanath.jpg
// module id = 247
// module chunks = 0